import { mountLegalPage } from './mount-legal';

mountLegalPage('terms');
